/**
 * Une catégorie de la boutique
 */
export class BoutiqueCategorie {
    /**
     * Constructeur de l'objet BoutiqueCategorie
     * @param contact contient les données de l'objet
     */
    constructor(categorieObj) {
        if (categorieObj) {
            const { actif, idCategorie, libelle } = categorieObj;
            this.actif = actif;
            this.idCategorie = idCategorie;
            this.libelle = libelle;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVDYXRlZ29yaWUuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJCb3V0aXF1ZUNhdGVnb3JpZS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxpQkFBaUI7SUFnQjdCOzs7T0FHRztJQUNILFlBQW1CLFlBQXlDO1FBQzNELElBQUksWUFBWSxFQUFFO1lBQ2pCLE1BQU0sRUFBRSxLQUFLLEVBQUUsV0FBVyxFQUFFLE9BQU8sRUFBRSxHQUFHLFlBQVksQ0FBQztZQUVyRCxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztZQUNuQixJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQztZQUMvQixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztTQUN2QjtJQUNGLENBQUM7Q0FDRCJ9